import { render, staticRenderFns } from "./ProductLabel.vue?vue&type=template&id=53018a80&scoped=true&"
import script from "./ProductLabel.vue?vue&type=script&lang=js&"
export * from "./ProductLabel.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabel.vue?vue&type=style&index=0&id=53018a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53018a80",
  null
  
)

export default component.exports